import raw from "../format.json";

/** A text colour (class `fg-c-<id>`) or a highlight colour (class `fg-h-<id>`). */
export interface RichColor {
    id: string;
    hex: string;
    label: string;
}

/** A font size (class `fg-s-<id>`). Normal size is the absence of the class. */
export interface RichSize {
    id: string;
    label: string;
    px: number;
}

/** A font family (class `fg-f-<id>`). `label` is the family's name; `stack` is the CSS font stack. No class = the default font.
 *  `offered: false`: still drawn when a message carries it, never in a font menu. */
export interface RichFont {
    id: string;
    label: string;
    stack: string;
    offered?: boolean;
}

export interface RichFormatData {
    colors: RichColor[];
    highlights: RichColor[];
    sizes: RichSize[];
    fonts: RichFont[];
}

/** Shared with the desktop apps: Shared/richformat/format.json. */
export const RICH_FORMAT: RichFormatData = raw as RichFormatData;
